import { render, staticRenderFns } from "./EnquetesRecebidas.vue?vue&type=template&id=6c6b5974&scoped=true"
import script from "./EnquetesRecebidas.vue?vue&type=script&lang=js"
export * from "./EnquetesRecebidas.vue?vue&type=script&lang=js"
import style0 from "./EnquetesRecebidas.vue?vue&type=style&index=0&id=6c6b5974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b5974",
  null
  
)

export default component.exports